import React, { useState } from 'react';
import Text from 'components/Text/Text';
import { CustomerSelect } from './CustomerSelect';
import { RememberMyChoiceCheckBox } from './RememberMyChoiceCheckBox';
import Button from 'components/Button/Button';
import { Link } from 'react-router-dom';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './index.module.scss';

interface IProps {
	setIDCustomer: (value: Nullable<string>) => void;
	toggleRememberMyChoice: () => void;
	rememberMyChoice: boolean;
}

export const ModalSelectCustomer: React.FC<IProps> = React.memo(
	({ setIDCustomer, toggleRememberMyChoice, rememberMyChoice }) => {
		const [selectedCustomer, setSelectedCustomer] = useState<Nullable<string>>(null);

		return (
			<div className={style.container} data-test="ModalSelectCustomer">
				<div className={style.wrapper}>
					<Link to="/home">
						<div className={style.closeIconWrapper}>
							<svg className={style.closeIcon}>
								<use xlinkHref={`${breadcrumbs}#resetIcon`} />
							</svg>
						</div>
					</Link>
					<Text
						className={style.description}
						translationNameSpace="modals"
						translationKey="selectFilters"
						size="xl"
						weight="bold"
						align="center"
					/>
					<Text
						translationNameSpace="modals"
						translationKey="startedSelectMandatoryFilter"
						size="s"
						align="center"
					/>
					<CustomerSelect setSelectedCustomer={setSelectedCustomer} selectedCustomer={selectedCustomer} />
					<RememberMyChoiceCheckBox
						toggleRememberMyChoice={toggleRememberMyChoice}
						rememberMyChoice={rememberMyChoice}
					/>
					<div className={style.btnWrapper}>
						<Link to="/home">
							<Button className={style.btn} theme="secondary" data-test="cancelButton">
								<Text translationNameSpace="modals" translationKey="cancelButton" asFragment={true} />
							</Button>
						</Link>
						<Button
							className={style.btn}
							theme="primaryBlue"
							onClick={() => setIDCustomer(selectedCustomer)}
							disabled={!selectedCustomer}
							type="submit"
							data-test="getStartedButton">
							<Text translationNameSpace="modals" translationKey="getStartedButton" asFragment={true} />
						</Button>
					</div>
				</div>
			</div>
		);
	},
);
